import { HeadAgreementStatusCode } from "@/gql/graphql";
import { HeadAgreement } from "../types";
import { formatGQLDate } from "@/lib/formatters/DateFormatter";
export const getIdsForMultiLegAgreementsToPrefill = (
  headAgreement: HeadAgreement
): Array<string> => {
  return headAgreement.multiLegAgrRoutes
    .filter((r) => {
      return (
        formatGQLDate(r.valid.end) === formatGQLDate(headAgreement.valid.end) &&
        r.statusCode === HeadAgreementStatusCode.Active
      );
    })
    .map((r) => r.id);
};
